import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39dd07fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Bryan White")
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  href: "https://github.com/bryanchriswhite/",
  target: "_blank"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "profile-picture",
  src: "/assets/bryan_white.jpg",
  alt: "profile picture"
}, null, -1))
const _hoisted_5 = {
  href: "https://www.linkedin.com/in/bryanchriswhite/",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Git Activity", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Programming Language Activity", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Technology Timeline", -1))
const _hoisted_9 = { class: "cta-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cta-title" }, "Products & Services", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cta-description" }, " Software products and consulting services in software development, technical management, and security auditing. ", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Learn More ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Featured Projects", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Published Security Audits", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Work Experience", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ThemeToggle = _resolveComponent("ThemeToggle")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_LocalGithubActivity = _resolveComponent("LocalGithubActivity")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_LocalSkillsChart = _resolveComponent("LocalSkillsChart")!
  const _component_LocalTechnologyTimeline = _resolveComponent("LocalTechnologyTimeline")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LocalProjects = _resolveComponent("LocalProjects")!
  const _component_LocalSecurityAudits = _resolveComponent("LocalSecurityAudits")!
  const _component_LocalWorkExperience = _resolveComponent("LocalWorkExperience")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ThemeToggle)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { id: "links-col" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_3, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.logoGithub,
                            class: "large-icon"
                          }, null, 8, ["icon"])
                        ]),
                        _hoisted_4,
                        _createElementVNode("a", _hoisted_5, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.logoLinkedin,
                            class: "large-icon"
                          }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      "size-md": "6",
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocalGithubActivity, {
                                  username: "bryanchriswhite",
                                  "use-git-hub-api": true,
                                  branding: false,
                                  "gitlab-base-url": "https://work.episkopos.community",
                                  "gitlab-username": "bryanchriswhite"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      "size-md": "6",
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocalSkillsChart, {
                                  username: "bryanchriswhite",
                                  "api-url": "/data/skills-merged.json",
                                  legend: true,
                                  tooltip: true,
                                  branding: false,
                                  skills: "auto",
                                  "show-other-skills": true
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocalTechnologyTimeline, {
                                  "api-url": "/data/timeline-data.json",
                                  "work-experience-data": _ctx.workExperienceData,
                                  branding: false
                                }, null, 8, ["work-experience-data"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, { class: "cta-card" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, { class: "cta-content" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_ion_icon, { icon: _ctx.rocketOutline }, null, 8, ["icon"])
                                ]),
                                _hoisted_10,
                                _hoisted_11,
                                _createVNode(_component_router_link, {
                                  to: "/products",
                                  class: "cta-button"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_12
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocalProjects, {
                                  "api-url": "/data/projects.json",
                                  branding: false
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocalSecurityAudits, {
                                  "api-url": "/data/security-audits.json",
                                  branding: false
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_LocalWorkExperience, {
                                  "api-url": "/data/work-experience.json",
                                  columns: _ctx.workExperienceColumns,
                                  branding: false
                                }, null, 8, ["columns"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}